import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseResponse } from '../models/rest/baseResponse';

export interface ToggleAcrobitsUserActiveByContactRequest {
  ContactId: number;
  IsActive: boolean;
  MobileDeviceId: string;
}

export interface ToggleAcrobitsUserActiveByContactResponse extends BaseResponse {}

export interface AcrobitsProvisioningResult extends BaseResponse {
  EmailSent: boolean;
}

@Injectable()
export class AcrobitsProvisioningService {
  constructor(private _httpClient: HttpClient) {}

  initialiseProvisioning(contactId: number): Observable<AcrobitsProvisioningResult> {
    return this._httpClient.post<AcrobitsProvisioningResult>(`Acrobits/Provisioning`, { ContactId: contactId }).pipe(
      map((response) => {
        return response;
      }),
    );
  }

  toggleAcrobitsUserActiveByContact(
    request: ToggleAcrobitsUserActiveByContactRequest,
  ): Observable<ToggleAcrobitsUserActiveByContactResponse> {
    return this._httpClient
      .put<ToggleAcrobitsUserActiveByContactResponse>(`Acrobits/Provisioning/Users/${request.ContactId}/Toggle`, {
        IsActive: request.IsActive,
        MobileDeviceId: request.MobileDeviceId,
      })
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }
}
